import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedStratalotFeeApiService } from './stratalot-fee-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class StratalotFeeApiService extends GeneratedStratalotFeeApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
